import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "@privacy/translations";
import { useCurrentOrganisation } from "../../../root/CurrentOrganisationProvider";

export const useScimEditingMode = () => {
  const { scimEnabled } = useCurrentOrganisation();
  return {
    isScimEnabled: scimEnabled,
    badge: scimEnabled ? <ScimEditingDisabledBadge /> : null,
  };
};

const ScimEditingDisabledBadge = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 2,
        py: 1,
        borderRadius: 1,
        width: "fit-content",
        backgroundColor: theme => theme.palette.action.hover,
      }}
    >
      <Typography
        component="span"
        variant="caption"
        sx={{ color: theme => theme.palette.text.tertiary, fontWeight: 600 }}
      >
        {t("ScimMapping.EditingDisabledLabel")}
      </Typography>
    </Box>
  );
};
